export default __webpack_public_path__ + "static/108161-cfa66863d4615f17ba57f5ef5310bc88.jpg";